import React from 'react'
import Box from "@mui/material/Box";
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';


const SearchBox = ({
  handleChangeTextValue,
  label,
  value,
  //setSearchValue,
  handleSearch,
  handleClearSearch
}) => {



  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end'}}>
        <TextField id="input-with-sx" value={value} label={label} variant="standard" onChange={handleChangeTextValue} />
        <SearchIcon onClick={handleSearch} sx={{cursor:'pointer', color: 'action.active', mr: 1, my: 0.5 }} />
        <ClearIcon onClick={handleClearSearch} sx={{cursor:'pointer', color: '#FF413A', my: 0.5 }} />
    </Box>
  )
}

export default SearchBox